import { parseDate, toQueryString, useProtrakApi } from '../../Core';

const instanceBase = '/instances';
const getConnectURL = '/relations';

export const generateStateFilterObj = stateFilter => {
  if (stateFilter && stateFilter.states && stateFilter.states.length) {
    return {
      stateFilter: stateFilter.states.map(state => {
        return state.name;
      })
    };
  }
  return {};
};

export const generateAttributeFilterObj = attributeFilterGroups => {
  if (!attributeFilterGroups || !attributeFilterGroups.length) {
    return null;
  }

  let filterGroup = {
    AttributeFilterExpressions: attributeFilterGroups.map(
      attributeFilterGroup => {
        return {
          AttributeFilterConditions: parsedArrayOfExpressions(
            attributeFilterGroup
          ),
          Operator: getOperator(attributeFilterGroup.operator)
        };
      }
    )
  };

  filterGroup.AttributeFilterExpressions.map(attributeFilterExpression => {
    return deleteNullOrUndefinedProperties(attributeFilterExpression);
  });
  return filterGroup;
};

const parsedArrayOfExpressions = group => {
  let filterExpressions = [];

  group.attributeFilterConditions &&
    group.attributeFilterConditions.forEach(groupExpression => {
      let filterExpression = {
        AttributeName: groupExpression.attributeName,
        Condition: groupExpression.condition,
        FirstValue: groupExpression.firstValue,
        SecondValue: groupExpression.secondValue,
        Operator: groupExpression.operator
      };

      deleteNullOrUndefinedProperties(filterExpression);

      filterExpressions.push(filterExpression);
    });

  return filterExpressions;
};

const deleteNullOrUndefinedProperties = objectToDeleteNullOrUndefined => {
  Object.keys(objectToDeleteNullOrUndefined).map(key => {
    return objectToDeleteNullOrUndefined[key] === undefined ||
      objectToDeleteNullOrUndefined[key] === '' ||
      objectToDeleteNullOrUndefined[key] === null
      ? delete objectToDeleteNullOrUndefined[key]
      : '';
  });
};

function getOperator(operator) {
  if (operator) {
    if (Array.isArray(operator)) {
      return operator[0];
    } else {
      return operator;
    }
  }
  return '';
}

export function useRelatedInstances({
  id,
  attributes,
  stateFilter,
  relationFilter,
  attributeFilter,
  params,
  defer = false
}) {
  const { state, run } = useProtrakApi(
    {
      requestConfig: relatedInstancesPromise,
      id,
      attributes,
      relationFilter,
      stateFilter,
      attributeFilter,
      params
    },
    { defer: defer }
  );
  return [state, run];
}

export const getRelationFilter = relationFilter => {
  return {
    RelationFilters: relationFilter.map(filter => {
      return {
        InstanceId: filter.instanceId,
        TypeName: filter.typeName,
        RelationTypeName: filter.relationTypeName,
        RelationDirection: filter.relationDirection
      };
    })
  };
};

const createRelatedInstEndpoint = (query, instanceId) => {
  if (query) {
    const queryParams = toQueryString(query);

    const endpoint = `${instanceBase}/${instanceId}/relatedInstances?${queryParams}`;

    return endpoint;
  }

  return null;
};

const relatedInstancesPromise = ({
  id,
  attributes,
  stateFilter,
  relationFilter,
  attributeFilter,
  params
}) => {
  const instanceQuery = {
    stateFilter,
    attributes,
    ...relationFilter,
    attributeFilterExpressions: attributeFilter,
    getOnlyConnectableInstances: true,
    ...params
  };
  const endpoint = createRelatedInstEndpoint(instanceQuery, id);
  return {
    endpoint: endpoint,
    config: {
      method: 'GET'
    }
  };
};

export function getRelationWidgetConfig(viewConfig, timezone) {
  if (
    viewConfig &&
    viewConfig.attributeFilter &&
    viewConfig.attributeFilter.attributeGroups
  ) {
    viewConfig.attributeFilter.attributeGroups.map(attributeGroup => {
      if (attributeGroup && attributeGroup.attributeFilterConditions) {
        attributeGroup.attributeFilterConditions.map(fc => {
          if (fc) {
            const attribute = viewConfig.fields.find(
              a => a.attributeName === fc.attributeName
            );
            if (
              attribute &&
              (attribute.attributeType === 'Date' ||
                attribute.attributeType === 'DateTime')
            ) {
              if (fc.firstValue) {
                fc.firstValue = parseDate(fc.firstValue, timezone);
              }
              if (fc.secondValue) {
                fc.secondValue = parseDate(fc.secondValue, timezone);
              }
            }
          }
          return fc;
        });
      }
      return attributeGroup;
    });
  }
  return viewConfig;
}

export function useConnectInstance() {
  const { state, run } = useProtrakApi(
    {
      requestConfig: connectInstance
    },
    { defer: true }
  );
  return [state, run];
}

const connectInstance = ({
  instanceId,
  relationTypeName,
  relationDirection,
  destinationInstanceId,
  relationAttributes
}) => {
  return {
    endpoint: getConnectURL,
    config: {
      method: 'POST',
      data: {
        relationTypeName: relationTypeName,
        sourceInstanceId: instanceId,
        direction: relationDirection,
        destinationInstanceId: destinationInstanceId,
        relationAttributes: relationAttributes
      }
    }
  };
};
